var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/x-local-stream-settings.ts
import { LocalStorageReactive } from "@adornis/base/rxjs-extension/index.js";
import "@adornis/base/utilTypes.js";
import { XDialog } from "@adornis/dialog/x-dialog.js";
import "@adornis/popover/x-dropdown-search-selection.js";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { state } from "lit/decorators/state.js";
import "./x-device-selector.js";
var localStreamSettings = new LocalStorageReactive("mediaConfig", {
  audioIn: "default",
  audioOut: "default",
  videoIn: ""
});
var LocalStreamSettingsDialog = class extends XDialog {
  constructor() {
    super(...arguments);
    this.newSettings = localStreamSettings.getValue();
  }
  static get element_name() {
    return "x-local-stream-settings";
  }
  render() {
    return html`
      <x-flex padding="lg" space="sm">
        <x-device-selector
          placeholder="AudioInput"
          kind="audioinput"
          .value=${this.newSettings.audioIn}
          @value-picked=${(e) => this.newSettings = { ...this.newSettings, audioIn: e.detail.value ?? "default" }}
        ></x-device-selector>
        <x-device-selector
          placeholder="VideoInput"
          kind="videoinput"
          .value=${this.newSettings.videoIn}
          @value-picked=${(e) => {
      if (e.detail.value)
        this.newSettings = { ...this.newSettings, videoIn: e.detail.value };
    }}
        ></x-device-selector>
        <x-flex horizontal space="md" space-between>
          <x-button
            @click=${() => {
      localStreamSettings.next(this.newSettings);
      void this.close();
    }}
          >
            Speichern
          </x-button>
          <x-button
            mode="outline"
            @click=${() => {
      void this.cancel();
    }}
          >
            Abbrechen
          </x-button>
        </x-flex>
      </x-flex>
    `;
  }
};
__decorateClass([
  state()
], LocalStreamSettingsDialog.prototype, "newSettings", 2);
LocalStreamSettingsDialog = __decorateClass([
  customElement("x-local-stream-settings")
], LocalStreamSettingsDialog);
export {
  LocalStreamSettingsDialog,
  localStreamSettings
};
